
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Chat } from 'src/app/shared/models/chat/chat';
import { ChatSearchResults } from 'src/app/shared/models/chat/chatSearchResults';
import { WebSocketMessage } from 'src/app/shared/models/chat/message';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { WebsocketService } from '../websocket.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class ChatApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService,
    protected wsService: WebsocketService) {
    super(spinner, errorService);
  }

  /***********************
    // Chats
    /***********************/
  public getChats = (params: SearchParams): Observable<ChatSearchResults> => {
    const p = this.serializeParamsObj(params, new HttpParams());
    return this.http.get<any>(`${this.baseUrl}/chat/`, { params: p })
      .pipe(map(this.deserializeAs(ChatSearchResults)));
  }

  public createChat = (c: Chat): Observable<Chat> => {
    return this.http.post<any>(`${this.baseUrl}/chat/`, this.serialize(c))
      .pipe(map(this.deserializeAs(Chat)));
  }

  public updateChat = (c: Chat): Observable<Chat> => {
    return this.http.put<any>(`${this.baseUrl}/chat/${c.id}`, this.serialize(c))
      .pipe(map(this.deserializeAs(Chat)));
  }

  /***********************
    // Websocket
    /***********************/
  public listenToChat = (uuid: string): Observable<WebSocketMessage> => {
    return this.wsService.connect(`chat/${uuid}`)
      .pipe(map(this.deserializeAs(WebSocketMessage)));
  }


  public sendMessageToChat = (msg: any) => {
    this.wsService.sendMessage(msg);
  }

  public sendTypingToChat = (content: any) => {
    this.wsService.updateTyping(content);
  }

  public fetchMessageFromChat = (uuid: string, page = 1) => {
    const data = {
      page,
      chatId: uuid,
      command: 'fetch_messages'
    }
    return this.wsService.sendMessage(data);
  }
  public CloseConnection() {
    this.wsService.closeConnection();
  }

}
